import { Injectable } from '@angular/core';
import Pusher from 'pusher-js';
import { environment } from '../../../../environments/environment';

@Injectable()
export class PusherService {
  pusher: any;
  channel: any;

  constructor() {
    const options: any = {
      cluster: environment.pusher.cluster,
      channelAuthorization: {
        endpoint: `${environment.whatsAppUrl}${environment.pusher.channelAuthorization.endpoint}`,
        transport: 'ajax',
        headers: {},
      },
    };

    if (environment?.isCookieEnable) {
      Pusher.Runtime.createXHR = () => {
        var xhr = new XMLHttpRequest();
        xhr.withCredentials = true;
        return xhr;
      };
    } else {
      options.channelAuthorization.headers = {
        AccessToken: localStorage.getItem('access_token'),
      };
    }
    this.pusher = new Pusher(environment.pusher.key, options);
  }

  subscribeChannel(organizationId: number) {
    this.channel = this.pusher.subscribe(
      `${environment.pusher.channel}${organizationId}`
    );
    return this.channel;
  }

  unsubscribeChannel(organizationId: number) {
    this.channel.unsubscribe(`${environment.pusher.channel}${organizationId}`);
  }
}
